import {Box} from "@mui/joy";
import HeroLanding from "./MainTiles/HeroLanding";

export default function MainScroll() {
    return (
        <Box sx={{display: 'flex', justifyContent: 'center', width: 1, height: 70, backgroundOpacity: 70, mt: 4}}>
            <HeroLanding/>
        </Box>
    )
}